var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.sliderComponent,{tag:"component",attrs:{"items":_vm.sliderItems,"preview-only":_vm.previewOnly,"is-desktop":_vm.isDesktop},scopedSlots:_vm._u([{key:"placeholder",fn:function(ref){
var item = ref.item;
return [_c('PlaceholderImage',{staticClass:"h-full w-full",attrs:{"label":item.title,"bg":"var(--color-stack-tile-bg)"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }